module.exports = __webpack_public_path__ + "static/media/request-frames-white.c54c6905.svg";